/* Google Fonts loaded via <link> in index.html for non-blocking render */

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0
}

/* Visually hidden — readable by crawlers and screen readers, invisible on screen */
.seo-h1 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}


:root {
  --ink: #0A0A0A;
  --paper: #F4F0E6;
  --paper2: #EDE9DA;
  --cream: #F9F6EE;
  --accent: #B91C1C;
  --accent2: #1A1AFF;
  --gold: #C8A84B;
  --muted: #6B6558;
  --border: #D5D0C2;
  --border-dark: #2A2A2A;
  --mono: 'JetBrains Mono', monospace;
  --display: 'Bebas Neue', cursive;
  --body: 'Archivo', sans-serif;
  --max-w: 1280px;
}

html {
  scroll-behavior: smooth;
  cursor: auto;
  overflow-x: hidden;
  max-width: 100vw;
}

body {
  background: var(--paper);
  color: var(--ink);
  font-family: var(--body);
  font-size: 15px;
  line-height: 1.6;
  overflow-x: hidden;
  max-width: 100vw;
}

/* CUSTOM CURSOR */
#cursor {
  position: fixed;
  width: 12px;
  height: 12px;
  background: var(--accent);
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  transform: translate(-50%, -50%);
  transition: transform .1s, width .25s, height .25s, background .25s;
  mix-blend-mode: multiply;
}

#cursor-ring {
  position: fixed;
  width: 40px;
  height: 40px;
  border: 1.5px solid var(--ink);
  border-radius: 50%;
  pointer-events: none;
  z-index: 9998;
  transform: translate(-50%, -50%);
  transition: transform .18s ease, width .3s, height .3s, border-color .3s;
}

body.cursor-hover #cursor {
  width: 40px;
  height: 40px;
  background: var(--accent);
  mix-blend-mode: multiply
}

body.cursor-hover #cursor-ring {
  width: 60px;
  height: 60px;
  border-color: var(--accent);
  opacity: .4
}

/* SCANLINE OVERLAY */
body::after {
  content: '';
  position: fixed;
  inset: 0;
  background: repeating-linear-gradient(0deg,
      transparent,
      transparent 2px,
      rgba(0, 0, 0, .012) 2px,
      rgba(0, 0, 0, .012) 4px);
  pointer-events: none;
  z-index: 9990;
}

/* SECTIONS — CONSISTENT SPACING */
.sec {
  padding: 6rem 0;
  border-top: 1px solid var(--border);
}

.sec-inner {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 0 3rem;
}

.sec-label {
  font-family: var(--mono);
  font-size: .62rem;
  letter-spacing: .25em;
  color: var(--accent);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: .8rem;
  margin-bottom: 1rem;
}

.sec-label::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border);
  max-width: 120px
}

.sec-title {
  font-family: var(--display);
  font-size: clamp(3rem, 6vw, 5.5rem);
  line-height: .95;
  letter-spacing: .03em;
  color: var(--ink);
  margin-bottom: 3rem;
}

.sec-title em {
  color: var(--accent);
  font-style: normal
}

/* UTILITY CLASSES */
.btn-blk {
  background: var(--ink);
  color: var(--paper);
  padding: .7rem 2rem;
  font-family: var(--mono);
  font-size: .72rem;
  letter-spacing: .1em;
  text-transform: uppercase;
  text-decoration: none;
  border: 2px solid var(--ink);
  transition: all .25s ease;
  display: inline-block;
}

.btn-blk:hover {
  background: var(--accent);
  border-color: var(--accent);
  transform: translateY(-2px)
}

.btn-ghost {
  background: transparent;
  color: var(--ink);
  padding: .7rem 2rem;
  font-family: var(--mono);
  font-size: .72rem;
  letter-spacing: .1em;
  text-transform: uppercase;
  text-decoration: none;
  border: 2px solid var(--ink);
  transition: all .25s ease;
  display: inline-block;
}

.btn-ghost:hover {
  background: var(--ink);
  color: var(--paper);
  transform: translateY(-2px)
}

/* ANIMATIONS - Robust reveal without blank screen risk */
.reveal {
  opacity: 1;
  transform: none;
  transition: opacity .6s cubic-bezier(.25, .46, .45, .94), transform .6s cubic-bezier(.25, .46, .45, .94);
}

.reveal.animate-pending {
  opacity: 0;
  transform: translateY(24px);
}

.reveal.in {
  opacity: 1 !important;
  transform: none !important;
}

/* SCROLLBAR */
::-webkit-scrollbar {
  width: 4px
}

::-webkit-scrollbar-track {
  background: var(--paper)
}

::-webkit-scrollbar-thumb {
  background: var(--border-dark);
  border-radius: 2px
}

/* SELECTION */
::selection {
  background: var(--accent);
  color: #fff
}

@media(max-width:1024px) {
  .sec {
    padding: 4rem 0
  }

  .sec-inner {
    padding: 0 1.5rem
  }
}

/* WHATSAPP FLOAT */
.wa-float {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  background: var(--accent);
  color: #fff;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 9995;
  transition: transform .3s ease;
  text-decoration: none;
}

.wa-float:hover {
  transform: scale(1.1) translateY(-3px);
  color: #fff;
}

/* SCROLL TO TOP */
.scroll-to-top {
  position: fixed;
  bottom: 2.3rem;
  right: 2rem;
  background: var(--accent);
  color: var(--paper);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: none;
  /* Let custom cursor handle it */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 9994;
  transition: all .3s ease;
  animation: fadeUp .3s ease forwards;
}

.scroll-to-top:hover {
  background: var(--ink);
  color: var(--accent);
  transform: translateY(-3px);
}

@media(max-width:1024px) {
  .wa-float {
    bottom: 1.2rem;
    left: 1.2rem;
    width: 44px;
    height: 44px;
    font-size: 1.4rem;
  }

  .scroll-to-top {
    bottom: 1.2rem;
    right: 1.2rem;
    width: 42px;
    height: 42px;
    font-size: 1rem;
  }
}

@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media(max-width:600px) {
  .wa-float {
    bottom: 1.5rem;
    left: 1.5rem;
    width: 45px;
    height: 45px;
    font-size: 1.5rem
  }

  .scroll-to-top {
    bottom: 1.6rem;
    right: 1.5rem;
    width: 40px;
    height: 40px;
    font-size: 1rem
  }
}


/* PRELOADER */
.preloader {
  position: fixed;
  inset: 0;
  background: var(--ink);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: plFadeOut 0.6s ease 1.6s forwards;
}

.pl-simple-text {
  font-size: 2.5rem;
  letter-spacing: 0.1em;
  color: var(--accent);
  text-transform: uppercase;
  text-align: center;
  /* Separate the font jumping and the smooth scaling/fading */
  animation:
    plFontChange 3.5s infinite,
    plSmoothPulse 1.2s infinite ease-in-out;
}

@keyframes plSmoothPulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0px);
  }

  50% {
    opacity: 0.7;
    transform: scale(0.98);
    filter: blur(1px);
  }
}

@keyframes plFontChange {

  0%,
  5% {
    font-family: var(--display);
    font-weight: normal;
    font-style: normal;
  }

  6%,
  11% {
    font-family: 'Palatino Linotype', 'Book Antiqua', serif;
    font-weight: normal;
    font-style: italic;
    text-transform: lowercase;
  }

  12%,
  18% {
    font-family: 'Century Gothic', 'Tw Cen MT', sans-serif;
    font-weight: bold;
    font-style: normal;
    letter-spacing: 0.2em;
  }

  19%,
  24% {
    font-family: 'Copperplate', 'Copperplate Gothic Light', fantasy;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0.15em;
  }

  25%,
  31% {
    font-family: 'Garamond', 'Georgia', serif;
    font-weight: normal;
    font-style: normal;
    text-transform: capitalize;
  }

  32%,
  37% {
    font-family: var(--mono);
    font-weight: normal;
    font-style: normal;
  }

  38%,
  43% {
    font-family: 'Optima', 'Segoe UI', sans-serif;
    font-weight: normal;
    font-style: italic;
  }

  44%,
  49% {
    font-family: 'Lucida Calligraphy', 'Brush Script MT', cursive;
    font-weight: bold;
    font-style: normal;
    text-transform: lowercase;
  }

  50%,
  55% {
    font-family: 'Didot', 'Bodoni MT', serif;
    font-weight: normal;
    font-style: normal;
  }

  56%,
  62% {
    font-family: 'Gill Sans', 'Gill Sans MT', sans-serif;
    font-weight: bold;
    font-style: normal;
  }

  63%,
  68% {
    font-family: var(--body);
    font-weight: bold;
    font-style: normal;
  }

  69%,
  74% {
    font-family: 'Baskerville', 'Baskerville Old Face', serif;
    font-weight: normal;
    font-style: italic;
  }

  75%,
  81% {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', sans-serif;
    font-weight: bold;
    font-style: normal;
    letter-spacing: 0.05em;
  }

  82%,
  87% {
    font-family: 'Consolas', monospace;
    font-weight: normal;
    font-style: normal;
    text-transform: lowercase;
  }

  88%,
  93% {
    font-family: 'Candara', 'Calibri', sans-serif;
    font-weight: normal;
    font-style: italic;
  }

  94%,
  100% {
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    font-style: normal;
    letter-spacing: 0.1em;
  }
}

@keyframes plFadeOut {
  to {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
}